import React from 'react'

import { Tooltip } from 'react-wot-bootstrap'

import { INDUSTRIAL_RESOURCE_MESSAGE, INDUSTRIAL_RESOURCE_TITLE } from './constants'

import styles from './IndustrialTooltip.scss'

export const IndustrialBuyinTooltip = () => {
    return (
        <Tooltip id={IndustrialBuyinTooltip.id}>
            <div className={styles.content}>
                <p className={styles.subtitle}>
                    {INDUSTRIAL_RESOURCE_TITLE}
                </p>
                <p className={styles.message}>
                    {INDUSTRIAL_RESOURCE_MESSAGE}
                </p>
            </div>
        </Tooltip>
    )
}

IndustrialBuyinTooltip.id = 'clan_panel_industrial_resource_buyin_tooltip'

export default IndustrialBuyinTooltip



// WEBPACK FOOTER //
// ./containers/ClanPanel/components/IndustrialBuyinTooltip/IndustrialBuyinTooltip.jsx